// Don't apply 'HeadingBuilder' for this component's 'Tippy content' ('submit' field)
import React, { useContext } from 'react';
import { ShopperContext } from '../context/shopper';
import HeadingBuilder from '../components/HeadingBuilder';
import 'tippy.js/dist/tippy.css';
import { useTranslation } from "react-i18next";

const EmailNoticeRow = () => {
  const { shopper, } = useContext(ShopperContext);
  const { t } = useTranslation();

  return (
    <tr>
      <td>
        <HeadingBuilder
          containerType='container-input-label'
          headingText = {t('circle.leader_email.label')}
          // Leader's Email
          labelHtmlFor = "leader_email_cf"
          tippyAlertText = {t('circle.leader_email.tippyContent')}
          tippyText = {t('circle.leader_email.tippyContent')}
        />
      </td>
      <td>
        <HeadingBuilder
          containerType  = 'container-left'
          headingText    = {shopper.email}
          // (Shopper's email address - they will become the leader.)
          linkUrl        = {`/shoppers/${shopper.id}/edit`}
          tippyAlertText = {t('circle.leader_email_link.tippyContent')}
          tippyText      = {t('circle.leader_email_link.tippyContent')}
          // You can change this email address by clicking the link here to access your profile.
        />
      </td>
    </tr>
  )
}

export default EmailNoticeRow;